import { render, staticRenderFns } from "./Castom.vue?vue&type=template&id=7624b178&"
import script from "./Castom.vue?vue&type=script&lang=js&"
export * from "./Castom.vue?vue&type=script&lang=js&"
import style0 from "./Castom.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports